import React, { useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import HelpIcon from "@mui/icons-material/Help";

// Custom.
import AccountIcon from "@vocollege/components/dist/AccountIcon";
import GroupSelect from "components/GroupSelect";
import LogoWhiteSvg from "@vocollege/theme/dist/images/vocollege_white.svg";
import { useStyles } from "./styles";
import { VoAppContext } from "services/GlobalState";
import VoHelp from "@vocollege/components/dist/VoHelp";
import VoApi from "@vocollege/app/dist/modules/VoApi";

const Header: React.FC = () => {
  const classes = useStyles();
  const { state, dispatch } = useContext(VoAppContext);

  return (
    <>
      <AppBar position="fixed" classes={{ root: classes.appBar }}>
        <Toolbar>
          <div className={classes.logoWrapper}>
            <img src={LogoWhiteSvg} alt={process.env.REACT_APP_NAME} />
          </div>

          {/* <Typography variant="h6" noWrap>
            {process.env.REACT_APP_NAME}
          </Typography> */}

          <div className={classes.grow} />
          <div className={classes.search}>
            {/* <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder={I18n.get.form.labels.searchField}
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ "aria-label": "search" }}
            /> */}
          </div>
          <div className={classes.sectionDesktop}>
            {/* <IconButton aria-label="show 4 new mails" color="inherit">
              <Badge badgeContent={4} color="secondary">
                <MailIcon />
              </Badge>
            </IconButton>
            <IconButton aria-label="show 17 new notifications" color="inherit">
              <Badge badgeContent={17} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton> */}
            {/* <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton> */}

            <GroupSelect className={classes.groupSelect} />

            <AccountIcon
              className={classes.menuButton}
              // className={clsx(classes.menuButton, classes.accountIcon)}
              // onChange={handleAccountChange}
            />
            <IconButton
              color="inherit"
              aria-label="Open help"
              className={classes.menuButton}
              onClick={() =>
                dispatch({ key: "helpOpen", values: !state.helpOpen })
              }
            >
              <HelpIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <VoHelp
        open={state.helpOpen}
        onClose={() => dispatch({ key: "helpOpen", values: false })}
        client={VoApi.graphqlClient}
        settingName="voadminDefaultHelpBook"
        enlargeImages
      />
    </>
  );
};

export default Header;
